import { Link } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';
import { FaultBadge } from '../status/FaultBadge';

export function Header({ systemMode, faultCount }: { systemMode?: string | undefined; faultCount: number }) {
  return (
    <header style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: 'var(--sp-3)', padding: 'var(--sp-3) 0', marginBottom: 'var(--sp-3)',
      borderBottom: '1px solid var(--border)',
    }}>
      <Link to="/" style={{ color: 'inherit' }}>
        <h1>UFH Controller</h1>
      </Link>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-3)' }}>
        {systemMode && <span className={`tag ${systemMode === 'heating' ? 'heat' : systemMode === 'cooling' ? 'cool' : 'none'}`}>{systemMode}</span>}
        <Link to="/settings" style={{ color: 'inherit' }}>Settings</Link>
        <FaultBadge count={faultCount} />
        <UserButton afterSignOutUrl="/sign-in" />
      </div>
    </header>
  );
}
